<template>
  <div class="edit-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ isEdit ? '编辑安装师傅' : '新增安装师傅' }}</span>
        <el-button style="float: right;" type="text" @click="goBack">返回</el-button>
      </div>
      
      <el-form :model="form" :rules="rules" ref="engineerForm" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="手机号" prop="mobile">
              <el-input v-model="form.mobile" placeholder="请输入手机号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码" prop="password">
              <el-input 
                v-model="form.password" 
                type="password" 
                :placeholder="isEdit ? '不填则不修改密码' : '请输入密码'"
                show-password>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="微信号" prop="wechat">
              <el-input v-model="form.wechat" placeholder="请输入微信号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="personalCode">
              <el-input v-model="form.personalCode" placeholder="请输入身份证号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="机构" prop="insId">
              <el-select
                v-model="form.insId"
                placeholder="请选择机构"
                filterable
                clearable
                style="width: 100%"
                @focus="loadCompanyList"
              >
                <el-option
                  v-for="item in companyOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="区域" prop="area">
              <el-cascader
                v-model="selectedArea"
                :options="areaOptions"
                :props="{ expandTrigger: 'hover', checkStrictly: true }"
                placeholder="请选择省市区"
                style="width: 100%"
                clearable
                @change="handleAreaChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="详细地址" prop="address">
              <el-input v-model="form.address" placeholder="请输入详细地址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="身份证正面" prop="frontSide">
              <div>
                <el-button @click="triggerFileInput('frontSide')">选择文件</el-button>
                <span style="margin-left: 20px; margin-right: 20px">{{ frontSideFileName || '' }}</span>
                <input
                  style="display: none"
                  type="file"
                  name="file"
                  accept="image/*"
                  @change="handleFileUpload($event, 'frontSide')"
                  ref="frontSideInput"
                />
                <el-button
                  size="mini"
                  round
                  v-show="form.frontSide"
                  @click="previewImage(form.frontSide)"
                >预览</el-button>
              </div>
              <el-image 
                v-if="form.frontSide" 
                style="width: 200px; height: 120px; margin-top: 10px;" 
                :src="form.frontSide" 
                fit="contain">
              </el-image>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证反面" prop="backSide">
              <div>
                <el-button @click="triggerFileInput('backSide')">选择文件</el-button>
                <span style="margin-left: 20px; margin-right: 20px">{{ backSideFileName || '' }}</span>
                <input
                  style="display: none"
                  type="file"
                  name="file"
                  accept="image/*"
                  @change="handleFileUpload($event, 'backSide')"
                  ref="backSideInput"
                />
                <el-button
                  size="mini"
                  round
                  v-show="form.backSide"
                  @click="previewImage(form.backSide)"
                >预览</el-button>
              </div>
              <el-image 
                v-if="form.backSide" 
                style="width: 200px; height: 120px; margin-top: 10px;" 
                :src="form.backSide" 
                fit="contain">
              </el-image>
            </el-form-item>
          </el-col>
        </el-row>

    <el-dialog :visible.sync="previewVisible" width="90%">
      <template>
        <iframe
          :src="previewImageUrl"
          style="width: 100%; height: 600px; border: none"
        ></iframe>
      </template>
    </el-dialog>

        <el-form-item style="margin-top: 30px;">
          <el-button type="primary" @click="submitForm">提交</el-button>
          <el-button @click="goBack">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import areaData from '@/assets/area-select-data.json';

export default {
  name: 'EngineerEdit',
  data() {
    // 手机号验证规则
    const validateMobile = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };
    
    // 身份证号验证规则
    const validateIdCard = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入身份证号'));
      } else if (!/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value)) {
        callback(new Error('请输入正确的身份证号'));
      } else {
        callback();
      }
    };
    
    return {
      isEdit: false,
      form: {
        id: null,
        password: '',
        mobile: '',
        wechat: '',
        personalCode: '',
        frontSide: '',
        backSide: '',
        insId: null,
        area: '',
        address: ''
      },
      areaOptions: areaData,
      selectedArea: [],
      companyOptions: [],
      frontSideFileName: '',
      backSideFileName: '',
      previewVisible: false,
      previewImageUrl: '',
      rules: {
        password: [
          { required: false, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        mobile: [
          { required: true, validator: validateMobile, trigger: 'blur' }
        ],
        personalCode: [
          { required: true, validator: validateIdCard, trigger: 'blur' }
        ],
        insId: [
          { required: true, message: '请选择机构', trigger: 'change' }
        ]
      }
    };
  },
  mounted() {
    const id = this.$route.query.id;
    
    if (id) {
      // 编辑模式：从 Vuex 中获取编辑数据
      const editInfo = this.$store.state.editInfo;
      
      // editInfo 可能是数组或对象，需要判断
      let editData = null;
      if (Array.isArray(editInfo)) {
        // 如果是数组且为空，说明没有数据
        if (editInfo.length === 0) {
          editData = null;
        } else {
          // 如果数组有数据，取第一个（虽然通常应该是对象）
          editData = editInfo[0];
        }
      } else if (editInfo && typeof editInfo === 'object') {
        // 如果是对象，直接使用
        editData = editInfo;
      }
      
      // 检查是否有有效数据，并且ID匹配
      const editDataId = editData ? (editData.id || editData.Id || null) : null;
      const routeId = parseInt(id);
      
      // 如果没有缓存数据或ID不匹配（用户刷新了页面），跳转到列表页
      if (!editData || !editDataId || parseInt(editDataId) !== routeId) {
        this.$message.warning('页面数据已丢失，正在跳转到列表页...');
        this.$router.push('/install/engineer/index');
        return;
      }
      
      this.isEdit = true;
      
      // 先加载机构列表
      this.loadCompanyList().then(() => {
        // 使用列表页传递的数据填充表单
        // 机构ID优先使用列表页搜索框传递的 ins_id
        this.form = {
          id: editData.id || editData.Id || id,
          password: '',
          mobile: editData.mobile || '',
          wechat: editData.wechat || '',
          personalCode: editData.personal_code || editData.personalCode || '',
          frontSide: editData.front_side || editData.frontSide || '',
          backSide: editData.back_side || editData.backSide || '',
          // 优先使用列表页搜索框传递的机构ID
          insId: editData.ins_id || editData.insId || null,
          area: editData.area || '',
          address: editData.address || ''
        };
        
        // 使用 $nextTick 确保机构列表已渲染后再设置值
        this.$nextTick(() => {
          // 回显省市区选择
          if (this.form.area) {
            this.selectedArea = this.getAreaValuesFromString(this.form.area);
          }
        });
      });
    } else {
      // 新增模式：密码必填
      this.rules.password[0].required = true;
      // 加载机构列表
      this.loadCompanyList();
    }
  },
  methods: {
    // 获取师傅详情（仅在 Vuex 中没有数据时调用）
    getDetail(id) {
      // 实际接口调用
      this.$http.get(`/manage/user-info/detail/${id}`)
        .then(res => {
          if (res.data.code === 0) {
            const data = res.data.data || {};
            // 统一处理字段名，接口可能返回 ins_id 或 insId
        this.form = {
              id: data.id || id,
              password: '',
              mobile: data.mobile || '',
              wechat: data.wechat || '',
              personalCode: data.personal_code || data.personalCode || '',
              frontSide: data.front_side || data.frontSide || '',
              backSide: data.back_side || data.backSide || '',
              insId: data.ins_id || data.insId || null,
              area: data.area || '',
              address: data.address || ''
            };
            
            // 使用 $nextTick 确保机构列表已渲染后再设置值
            this.$nextTick(() => {
              // 回显省市区选择
              if (this.form.area) {
                this.selectedArea = this.getAreaValuesFromString(this.form.area);
              }
            });
          } else {
            this.$message.error(res.data.message || '获取详情失败');
          }
        })
        .catch(err => {
          this.$message.error('网络请求失败');
          console.error(err);
        });
    },
    
    // 触发文件选择
    triggerFileInput(field) {
      if (field === 'frontSide') {
        this.$refs.frontSideInput.click();
      } else if (field === 'backSide') {
        this.$refs.backSideInput.click();
      }
    },
    
    // 处理文件上传
    handleFileUpload(event, field) {
      const file = event.target.files[0];
      if (!file) return;
      
      // 验证文件类型
      if (!file.type.startsWith('image/')) {
        this.$message.error('请选择图片文件');
        event.target.value = '';
        return;
      }
      
      // 验证文件大小（限制为5MB）
      if (file.size > 5 * 1024 * 1024) {
        this.$message.error('图片大小不能超过5MB');
        event.target.value = '';
        return;
      }
      
      // 显示文件名
      if (field === 'frontSide') {
        this.frontSideFileName = file.name;
      } else if (field === 'backSide') {
        this.backSideFileName = file.name;
      }
      
      // 上传文件
      const headers = {
        'Content-Type': 'multipart/form-data'
      };
      const formData = new FormData();
      formData.append('file', file);
      
      this.$http.post('/manage/file/upload', formData, { headers })
        .then(res => {
          if (res.data.code === 0) {
            // 接口返回的路径在 message 字段中
            const fileUrl = res.data.message;
            if (field === 'frontSide') {
              this.form.frontSide = fileUrl;
            } else if (field === 'backSide') {
              this.form.backSide = fileUrl;
            }
            this.$message.success('上传成功');
          } else {
            this.$message.error(res.data.message || '上传失败');
          }
        })
        .catch(err => {
          this.$message.error('上传失败');
          console.error(err);
        })
        .finally(() => {
          // 清空文件选择，允许重复选择同一文件
          event.target.value = '';
        });
    },
    
    // 预览图片
    previewImage(url) {
      this.previewImageUrl = url;
      this.previewVisible = true;
    },

    // 加载机构列表
    loadCompanyList() {
      if (this.companyOptions.length > 0) {
        return Promise.resolve(); // 已加载过，返回已解决的Promise
      }
      
      const params = {
        pageNum: 1,
        pageSize: 1000
      };
      
      return this.$http.post('/manage/institution/list', params)
        .then(res => {
          if (res.data.code === 0) {
            this.companyOptions = res.data.data.records || [];
          } else {
            this.$message.error(res.data.message || '获取机构失败');
          }
        })
        .catch(err => {
          console.error(err);
          this.$message.error('获取机构失败');
        });
    },
    
    // 处理省市区选择变化
    handleAreaChange(value) {
      if (value && value.length > 0) {
        const labels = this.getAreaLabels(value);
        // 将省市区拼接成字符串，格式：省|市|区
        this.form.area = labels.filter(Boolean).join('|');
      } else {
        this.form.area = '';
      }
    },
    
    // 根据选中的value获取label
    getAreaLabels(values) {
      const labels = [];
      let currentOptions = this.areaOptions;
      
      for (let i = 0; i < values.length; i++) {
        const item = currentOptions.find(opt => opt.value === values[i]);
        if (item) {
          labels.push(item.label);
          currentOptions = item.children || [];
        }
      }
      
      return labels;
    },
    
    // 根据区域字符串（格式：省|市|区）获取value数组
    getAreaValuesFromString(areaString) {
      if (!areaString) return [];
      
      const parts = areaString.split('|');
      if (parts.length === 0) return [];
      
      const values = [];
      
      // 查找省
      const provinceItem = this.areaOptions.find(p => p.label === parts[0]);
      if (!provinceItem) return [];
      values.push(provinceItem.value);
      
      if (parts.length < 2 || !provinceItem.children) return values;
      
      // 查找市
      const cityItem = provinceItem.children.find(c => c.label === parts[1]);
      if (!cityItem) return values;
      values.push(cityItem.value);
      
      if (parts.length < 3 || !cityItem.children) return values;
      
      // 查找区
      const districtItem = cityItem.children.find(d => d.label === parts[2]);
      if (!districtItem) return values;
      values.push(districtItem.value);
      
      return values;
    },
    
    // 提交表单
    submitForm() {
      this.$refs.engineerForm.validate((valid) => {
        if (valid) {
          const url = this.isEdit ? '/manage/user-info/updateEngineer' : '/manage/user-info/saveEngineer';
          const submitData = { ...this.form };
          
          // 将 username 和 userno 赋值手机号
          submitData.username = this.form.mobile;
          submitData.userno = this.form.mobile;
          
          // 区域由省市区选择器生成，已保存在 form.area
          
          // 如果是新增（id为null），则不传递id字段
          if (!submitData.id || submitData.id === null) {
            delete submitData.id;
          }
          
          // 如果是编辑且密码为空，则不提交密码字段
          if (this.isEdit && !submitData.password) {
            delete submitData.password;
          }
          
          this.$http.post(url, submitData)
            .then(res => {
              if (res.data.code === 0) {
                this.$message.success(this.isEdit ? '修改成功' : '创建成功');
                this.goBack();
              } else {
                this.$message.error(res.data.message || '操作失败');
              }
            })
            .catch(err => {
              this.$message.error('操作失败');
              console.error(err);
            });
        } else {
          this.$message.error('请检查表单填写');
          return false;
        }
      });
    },
    
    // 返回
    goBack() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.edit-container {
  padding: 20px;
}
.box-card {
  width: 100%;
  margin: 0 auto;
}
</style>

